import React, { useMemo, useState } from 'react';
import { ChatImage } from 'types/Chat';
import { ImageGalleryViewer } from 'components/_new/ImageGalleryViewer';
import { GalleryImage } from 'components/_new/ImageGalleryViewer/ImageGalleryViewer';

type ChatImageGridProps = {
	images: ChatImage[];
	galleryImages?: GalleryImage[];
};

export const ChatImageGrid = ({ images, galleryImages }: ChatImageGridProps) => {
	const [viewerVisible, setViewerVisible] = useState(false);
	const [activeIndex, setActiveIndex] = useState(0);
	const finalGalleryImages = galleryImages || images;

	const previewImages = useMemo(
		() =>
			images.slice(0, 5).map((image, index) => {
				const remainingCount = images.length - 4;
				const isMoreTile = index === 4 && images.length > 5;
				return (
					<button
						key={image.id}
						type="button"
						className={`chat-message-image${isMoreTile ? ' chat-message-image-more' : ''}`}
						onClick={() => {
							const nextIndex = finalGalleryImages.findIndex(
								(galleryImage) => galleryImage.id === image.id
							);
							setActiveIndex(nextIndex >= 0 ? nextIndex : index);
							setViewerVisible(true);
						}}
					>
						<img src={image.thumbUrl} alt="" />
						{isMoreTile ? <span className="chat-message-image-more__label">+{remainingCount}</span> : null}
					</button>
				);
			}),
		[finalGalleryImages, images]
	);

	if (images.length === 0) {
		return null;
	}

	return (
		<>
			<div className="chat-message-images">{previewImages}</div>
			<ImageGalleryViewer
				images={finalGalleryImages}
				activeIndex={activeIndex}
				visible={viewerVisible}
				onClose={() => setViewerVisible(false)}
				onChangeIndex={setActiveIndex}
			/>
		</>
	);
};
